"use client"

import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import icon1 from "../../images/icons/icon_wifi.svg"
import icon2 from "../../images/icons/icon_dollar_2.svg"
import icon5 from "../../images/icons/icon_user_2.svg"
import icon6 from "../../images/icons/icon_users.svg"
import icon10 from "../../images/avatar/avatar_7.webp"
import logo from "../../images/site_logo/site_logo_3.webp"
import cases from "../../images/case/case_image_4.webp"
import MobileMenu from "../MobileMenu/MobileMenu"
import PopupModal from "../LeadInquary/LeadInquary"
import facebook from "../../images/icons/facebook.webp"
import instagram from "../../images/icons/instagram.webp"
import linkedin from "../../images/icons/linkedin.webp"
import pinterest from "../../images/icons/pinterest.webp"
import x from "../../images/icons/twitter.webp"
import youtube from "../../images/icons/youtube.webp"
import ld from "../../images/icons/linkedin_result.webp"
import twitter from "../../images/icons/twitter_result.webp"

const Header = (props) => {
  const [mobailActive, setMobailState] = useState(false)
  const [modalKey, setModalKey] = useState(0)
  const [showPopup, setShowPopup] = useState(false)

  const handleClick = () => {
    setShowPopup(true)
  }

  const handleClose = () => {
    setShowPopup(false)
  }
  const ClickHandler = () => {
    window.scrollTo(10, 0)
  }

  const [isSticky, setSticky] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true)
      } else {
        setSticky(false)
      }
    }

    window.addEventListener("scroll", handleScroll)

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <header className="site_header site_header_1">
      {showPopup && <PopupModal showPopup={showPopup} setShowPopup={setShowPopup} />}
      <div className="header_top text-center">
        <div className="container">
          <p className="m-0">
            We are hiring!{" "}
            <Link onClick={ClickHandler} to="/career">
              <u>Join us</u> <i className="fa-solid fa-angle-right"></i>
            </Link>
          </p>
        </div>
      </div>
      <div className={`header_bottom stricky  ${isSticky ? "stricked-menu stricky-fixed" : ""}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-3 col-lg-2 col-5">
              <div className="site_logo">
                <Link onClick={ClickHandler} className="site_link" to="/">
                  <img
                    src={logo || "/placeholder.svg"}
                    alt="Site Logo – Techco – IT Solutions & Technology, Business Consulting, Software Company Site Template"
                  />
                </Link>
              </div>
            </div>
            <div className="col-xl-6 col-lg-7 col-2">
              <nav className="main_menu navbar navbar-expand-lg">
                <div
                  className="main_menu_inner collapse navbar-collapse justify-content-lg-center"
                  id="main_menu_dropdown"
                >
                  <ul className="main_menu_list unordered_list justify-content-center">
                    <li>
                      <Link
                        className="nav-link"
                        to="/"
                        id="home_submenu"
                        onClick={ClickHandler}
                        role="button"
                        aria-expanded="false"
                      >
                        Home
                      </Link>
                    </li>
                    <li className="dropdown">
                      <Link
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/"
                        id="company_submenu"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Company
                      </Link>

                      <ul className="dropdown-menu" aria-labelledby="company_submenu">
                        <li>
                          <Link className="dropdown-item" to="/about" onClick={ClickHandler}>
                            About Us
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/blog" onClick={ClickHandler}>
                            Blog
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/career" onClick={ClickHandler}>
                            Career
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle"
                        to="#"
                        id="ourworkDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        onClick={ClickHandler}
                      >
                        Our Work
                      </Link>

                      <ul className="dropdown-menu" aria-labelledby="ourworkDropdown">
                        <li>
                          <Link className="dropdown-item" to="/portfolio" onClick={ClickHandler}>
                            Portfolio
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/case-study" onClick={ClickHandler}>
                            Case Study
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li className="dropdown">
                      <Link
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/services"
                        id="services_submenu"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Services
                      </Link>
                      <div className="dropdown-menu mega_menu_wrapper p-0" aria-labelledby="services_submenu">
                        <div className="container">
                          <div className="row justify-content-lg-between">
                            <div className="col-lg-9">
                              <div className="row">
                                {/* Services Column */}
                                <div className="col-lg-4">
                                  <div className="megamenu_widget">
                                    <h3 className="megamenu_info_title">Services</h3>
                                    <ul className="icon_list unordered_list_block">
                                      <li>
                                        <Link onClick={ClickHandler} to="/web-development-services">
                                          <span className="icon_list_text">Web Development</span>
                                        </Link>
                                      </li>
                                      <li>
                                        <Link onClick={ClickHandler} to="/app-development-services">
                                          <span className="icon_list_text">App Development</span>
                                        </Link>
                                      </li>
                                      <li>
                                        <Link onClick={ClickHandler} to="/e-commerce-solutions-services">
                                          <span className="icon_list_text">E‑commerce Solutions</span>
                                        </Link>
                                      </li>
                                      <li>
                                        <Link onClick={ClickHandler} to="/custom-software-services">
                                          <span className="icon_list_text">Custom Software</span>
                                        </Link>
                                      </li>
                                      <li>
                                        <Link onClick={ClickHandler} to="/ui-ux-development-services">
                                          <span className="icon_list_text">UI/UX Development</span>
                                        </Link>
                                      </li>
                                      <li>
                                        <Link onClick={ClickHandler} to="/graphic-design-services">
                                          <span className="icon_list_text">Graphic Design</span>
                                        </Link>
                                      </li>
                                      <li>
                                        <Link onClick={ClickHandler} to="/video-editing-services">
                                          <span className="icon_list_text">Video Editing</span>
                                        </Link>
                                      </li>
                                      <li>
                                        <Link onClick={ClickHandler} to="/seo-services">
                                          <span className="icon_list_text">SEO</span>
                                        </Link>
                                      </li>
                                      <li>
                                        <Link onClick={ClickHandler} to="/smo-services">
                                          <span className="icon_list_text">SMO</span>
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <div className="col-lg-8">
                                  <div className="megamenu_widget">
                                    <h3 className="megamenu_info_title mb-4">Our Industries</h3>
                                    <div className="row">
                                      {/* First Column of Industries */}
                                      <div className="col-md-6">
                                        <ul className="icon_list unordered_list_block">
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/healthcare">
                                              <span className="icon_list_text">Healthcare</span>
                                            </Link>
                                          </li>
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/education">
                                              <span className="icon_list_text">Education & E‑Learning</span>
                                            </Link>
                                          </li>
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/finance">
                                              <span className="icon_list_text">Finance</span>
                                            </Link>
                                          </li>
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/legal-consultancy">
                                              <span className="icon_list_text">Legal & Consultancy</span>
                                            </Link>
                                          </li>
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/logistics">
                                              <span className="icon_list_text">Logistics</span>
                                            </Link>
                                          </li>
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/insurance">
                                              <span className="icon_list_text">Insurance</span>
                                            </Link>

                                          </li>
                                           <li>
                                            <Link onClick={ClickHandler} to="/industries/manufacturing">
                                              <span className="icon_list_text">Manufacturing</span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>

                                      {/* Second Column of Industries */}
                                      <div className="col-md-6">
                                        <ul className="icon_list unordered_list_block">
                                         
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/travel">
                                              <span className="icon_list_text">Travel</span>
                                            </Link>
                                          </li>
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/retail">
                                              <span className="icon_list_text">Retail</span>
                                            </Link>
                                          </li>
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/construction">
                                              <span className="icon_list_text">Construction</span>
                                            </Link>
                                          </li>
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/sports">
                                              <span className="icon_list_text">Sports</span>
                                            </Link>
                                          </li>
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/marketplace">
                                              <span className="icon_list_text">Marketplace</span>
                                            </Link>
                                          </li>
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/beauty-lifestyle">
                                              <span className="icon_list_text">Beauty & Lifestyle</span>
                                            </Link>
                                          </li>
                                          <li>
                                            <Link onClick={ClickHandler} to="/industries/on-demand">
                                              <span className="icon_list_text">On Demand</span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="social_area">
                                <ul className="social_icons_block unordered_list" data-text="Follow Us:">
                                  <li>
                                    <a href="https://www.facebook.com/rashtechinfo" target="_blank" rel="noreferrer">
                                      <img
                                        src={facebook || "/placeholder.svg"}
                                        alt="Facebook Icon"
                                        style={{ width: "18px" }}
                                      />
                                    </a>
                                  </li>
                                  <li>
                                    <a href="https://x.com/rashtechinfo" target="_blank" rel="noreferrer">
                                      <img src={x || "/placeholder.svg"} alt="X Icon" style={{ width: "18px" }} />
                                    </a>
                                  </li>
                                  <li>
                                    <a href="https://www.instagram.com/rashtechinfo" target="_blank" rel="noreferrer">
                                      <img
                                        src={instagram || "/placeholder.svg"}
                                        alt="Instagram Icon"
                                        style={{ width: "18px" }}
                                      />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="https://www.linkedin.com/company/officialrashtechinfo"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <img
                                        src={linkedin || "/placeholder.svg"}
                                        alt="LinkedIn Icon"
                                        style={{ width: "18px" }}
                                      />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="https://www.youtube.com/@officialrashtechinfo"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <img
                                        src={youtube || "/placeholder.svg"}
                                        alt="YouTube Icon"
                                        style={{ width: "18px" }}
                                      />
                                    </a>
                                  </li>
                                  <li>
                                    <a href="https://in.pinterest.com/rashtech_info" target="_blank" rel="noreferrer">
                                      <img
                                        src={pinterest || "/placeholder.svg"}
                                        alt="Pinterest Icon"
                                        style={{ width: "18px" }}
                                      />
                                    </a>
                                  </li>
                                </ul>
                                <p className="career_link m-0">
                                  Looking for new career?{" "}
                                  <Link onClick={ClickHandler} to="/career">
                                    We're Hiring
                                  </Link>
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="megamenu_case bg-primary">
                                <h3>Computer Software</h3>
                                <h4>Astarte Medical</h4>
                                <img src={cases || "/placeholder.svg"} alt="Case" />
                                <Link onClick={ClickHandler} className="btn" to="/case-study">
                                  <span className="btn_label" data-text="Read Case">
                                    Read Case
                                  </span>
                                  <span className="btn_icon">
                                    <i className="fa-solid fa-arrow-up-right"></i>
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li>
                      <Link onClick={ClickHandler} to="/contact">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
            <div className="col-xl-3 col-lg-3 col-5">
              <ul className="header_btns_group unordered_list justify-content-end">
                <li>
                  <button
                    className="mobile_menu_btn"
                    onClick={() => setMobailState(!mobailActive)}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#main_menu_dropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <i className="far fa-bars"></i>
                  </button>
                </li>
                <li>
                  <span
                    onClick={() => {
                      handleClick()
                    }}
                    className="btn btn-outline-light"
                  >
                    <span className="btn_label" data-text="Get Started">
                      Get Started
                    </span>
                    <span className="btn_icon">
                      <i className="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mobail-wrap">
          <div className={`mobail-menu ${mobailActive ? "active" : ""}`}>
            <div className="xb-header-menu-scroll">
              <div className="xb-menu-close xb-hide-xl xb-close" onClick={() => setMobailState(!mobailActive)}></div>
              <nav className="xb-header-nav">
                <MobileMenu />
              </nav>
            </div>
          </div>
          <div className="xb-header-menu-backdrop" onClick={() => setMobailState(false)}></div>
        </div>
      </div>
    </header>
  )
}

export default Header